import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'dva';

import Button from '../../Button';
import X from '../../../assets/svg/Feather/X';
import styles from './SceneDisabledModal.module.scss';

function SceneDisabledModal(props) {

  const closeModal = () => {
    props.dispatch({
      type: 'modals/close'
    });
  };

  return (
    <div className={styles.container}>
      <button className={styles.closeButton} onClick={closeModal}>
        <X width={14} color='#939393' />
      </button>
      <h1 className={styles.title}>Feature Not Supported</h1>
      <p className={styles.body}>This feature is not supported by your device. Click below to learn more about the system requirements.</p>
      <div className={styles.actionButtons}>
        <Button 
          theme={Button.THEME.orange}
          size={Button.SIZE.medium}
          className={styles.actionItem}
          href="https://doc.arcgis.com/en/arcgis-online/reference/scene-viewer-requirements.htm"
        >
          Learn more
        </Button>
      </div>
    </div>
  );
}

SceneDisabledModal.propTypes = {
};

export default connect(() => ({}))(SceneDisabledModal);